import dayjs from 'dayjs'

export const DELIVERY_TYPE = {
  IDLE: 'IDLE',
  EATIN: 'EATIN',
  TAKEAWAY: 'TAKEAWAY',
} as const

export type DeliveryType = typeof DELIVERY_TYPE[keyof typeof DELIVERY_TYPE]


export const DELIVERY_ITEM_TYPE = {
  EATIN: 600,
  TAKEAWAY_METHOD: 400,
  TAKEAWAY_DEFAULT: 700,
}

export type DeliveryDayT = { 
  isAvailable: boolean, 
  dayNumber: number, 
  startTime: string, 
  endTime: string 
}

export type DeliveryMethodT = {
  id: string,
  name: string,
  deliveryTime: string | undefined
  description: string | undefined
  price: number
  availabilityHours: Array<DeliveryDayT>
  deliveryType?: 'EatOnSite' | 'Pickup' | string
}

export type DeliveryMethodsT = Array<DeliveryMethodT>

export const isAvailable = (day: DeliveryDayT): boolean => {
  const now = dayjs()
  const dayNumber = now.day()

  const isDayAvailable = day.isAvailable && day.dayNumber === dayNumber

  if (!isDayAvailable) {
    return false
  }

  const [startHours, startMinutes] = day.startTime.split(':').map(Number)
  const [endHours, endMinutes] = day.endTime.split(':').map(Number)

  const dayStartTime = now.set('hour', startHours).set('minute', startMinutes).set('second', 0)
  const dayEndTime = now.set('hour', endHours).set('minute', endMinutes).set('second', 0)

  const isTimeAvailable =
    (now.isSame(dayStartTime) || now.isAfter(dayStartTime)) &&
    (now.isSame(dayEndTime) || now.isBefore(dayEndTime)) ||
    (day.startTime === '01:00' && day.endTime === '01:00')

  return isTimeAvailable
}

export const getDeliveryDisplayText = (deliveryOption: 'eatin' | 'takeaway' | null): string => {
  return deliveryOption === 'eatin' ? 'Äta här' : 'Ta med'
}